import { useState } from 'react';
import clsx from 'clsx';
import { useLocation, useNavigate } from 'react-router-dom';

import { useBuildingSearch } from 'api/hooks/use-building-search';
import { IPolygonItemRequest } from 'api/hooks/use-apartments-limits-secondary';
import { BuyApartmentFlowPaths } from '../../routes';

import TextInput from '../text-input';
import Tab from '../tab';
import { StreetsTab } from '../streets-tab';
import ChooseMapPolygon from '../items-ymap/Polygon/ChooseMapPolygon';

import { MarketTypes } from 'api/types';
import useBoundStore from 'store';

import styles from './styles.module.scss';

export type TabsProps = {
  tabsContainerClassName?: string;
  contentClassName?: string;
  defaultTab: string;
  polygons: IPolygonItemRequest[];
  selectedIds: number[];
  setSelectedIds: (ids: number[]) => void;
};

const TabsSecondary: React.FC<TabsProps> = (props) => {
  const tabs = [
    { key: '#address', title: 'По адресу' },
    { key: '#map', title: 'На карте' },
  ];
  const {
    contentClassName,
    tabsContainerClassName,
    defaultTab = '#address',
    setSelectedIds,
    selectedIds,
    polygons,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [query, setQuery] = useState('');
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const { buildings, isLoading } = useBuildingSearch();
  const handleSelectTab = (tabHash: string) => () => {
    navigate(`${BuyApartmentFlowPaths.buySecondaryStreetMap}/${tabHash}`, { replace: true });
    setSelectedTab(tabHash);
  };

  const screenPadding = useBoundStore((s) => s.screenPadding);

  return (
    <>
      <div className={clsx(styles.tabsSecondary, tabsContainerClassName)}>
        {tabs.map((item) => (
          <Tab
            key={item.key}
            onClick={handleSelectTab(item?.key)}
            title={item.title}
            selected={location?.hash === item?.key}
          />
        ))}
      </div>

      <div className={selectedTab === '#address' ? contentClassName : ''}>
        <>
          {selectedTab === '#address' ? (
            <StreetsTab
              buildings={buildings.filter((i) =>
                i.streetName.toLocaleLowerCase().includes(query.toLocaleLowerCase()),
              )}
              isLoading={isLoading}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
            />
          ) : (
            <div
              style={{
                marginBottom: 0,
                height: `calc(100vh - ${screenPadding}px - 56px)`,
              }}
            >
              <ChooseMapPolygon type={MarketTypes.SECONDARY} polygonItems={polygons} />
            </div>
          )}
          {selectedTab === '#address' && (
            <TextInput
              tall
              value={query}
              onChange={setQuery}
              placeholder='Поиск по адресу'
              className={styles.mapSearchInput}
            />
          )}
        </>
      </div>
    </>
  );
};

export default TabsSecondary;
